import { FC, useState } from "react";
import styles from "./ProfileHeader.module.css"; // Importing CSS Module
import { FaEdit } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useAuth } from "../../../context/AuthProvider";
import { useFetchedUserContext } from "../../../context/fetchedUser/FetchedUser";
import globalStyle from "../../../styles/globalStyles.module.css";
import { ReportButton } from "../../Buttons/ReportButton/ReportButton";
import { ShareButton } from "../../Buttons/ShareButton/ShareButton";
import { useTranslation } from "react-i18next";
import { FaEllipsisV } from "react-icons/fa";

const ProfileHeader: FC = () => {
  const auth = useAuth();
  const { user, nbFollowers, unfollow, follow, isFollowing } =
    useFetchedUserContext();
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <div className={styles.bannerContainer}>
        <img
          src={
            user?.banner_image_url
              ? user.banner_image_url
              : "/images/default/profilePicture.svg"
          }
          alt="Creator Profile"
          className={styles.bannerImage}
        />
        <div className={styles.headerContainer}>
          <div className={`${styles.profilePictureContainer}`}>
            <img
              src={
                user?.profile_picture_url
                  ? user.profile_picture_url
                  : "/images/default/profilePicture.svg"
              }
              alt="Creator Profile"
              className={styles.profilePicture}
            />

            <div className={styles.headerButtons}>
              <div className={styles.userNameFollow}>
                <div className={styles.creatorName}>{user?.username}</div>
                {auth.user?.username !== user?.username && (
                  <button
                    className={globalStyle.button}
                    onClick={() =>
                      isFollowing ? unfollow(user!.id) : follow(user!.id)
                    }
                  >
                    {isFollowing ? t("unfollow") : t("follow")}
                  </button>
                )}
              </div>
              <div className={styles.buttonGroup}>
                {/* Desktop: show buttons */}
                <div className={styles.buttonGroupDesktop}>
                  {auth.user?.username === user?.username && (
                    <Link to="/account/edit" className={globalStyle.unset}>
                      <div className={globalStyle.button}>
                        <FaEdit />
                      </div>
                    </Link>
                  )}
                  <ShareButton />
                  <ReportButton />
                </div>
                {/* Mobile: show 3-dots menu */}
                <div className={styles.buttonGroupMobile}>
                  <button
                    className={globalStyle.button}
                    onClick={() => setMenuOpen((open) => !open)}
                  >
                    <FaEllipsisV />
                  </button>
                  {menuOpen && (
                    <div className={styles.menuDropdown}>
                      {auth.user?.username === user?.username && (
                        <Link to="/account/edit" className={globalStyle.unset}>
                          <div className={globalStyle.button}>
                            <FaEdit />
                          </div>
                        </Link>
                      )}
                      <ShareButton />
                      <ReportButton />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className={styles.creatorInfo}>
            <div>
              {nbFollowers} {t("followers")}{" "}
            </div>
            <div>{user?.description}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfileHeader;
